import { createReduxEnhancer, initMonitoring } from '@doordash/lib-monitoring'
import {
  createTarget,
  middleware as trackingMiddleware,
  Segment,
} from '@doordash/lib-tracking'
import { routerMiddleware } from 'react-router-redux'
import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { getInitialState, reducer, RootState } from '../reducers'
import { get } from 'lodash'
import addSourceMiddleware from '../instrumentation/sourceMiddleware'

declare const dataLayer

const createHistory = require('history').createBrowserHistory

let store

export default (initialState?: any) => {
  initMonitoring('ddw-dasher-web', {
    dsn: 'https://954a9e346c05400c9ab2d5c560752cc8@sentry.io/1340544',
    beforeSend: (event, hint) => {
      let gtm = false
      try {
        const stack = get(hint, 'originalException.stack')
        if (stack) {
          gtm = stack.indexOf('www.googletagmanager.com/gtm.js?id=') > -1
        }
      } catch (error) {
        console.error(error)
      }

      event.tags = event.tags || {}
      event.extra = event.extra || {}

      if (gtm) {
        event.tags.logger = 'gtm'
        event.extra.dataLayer = dataLayer.map(i => {
          try {
            return JSON.stringify(i, null, ' ')
          } catch (error) {
            return `[cannot be serialized]: ${error.message}`
          }
        })
      }
      event.tags.logger = event.tags.logger || '_default_'
      return event
    },
  })
  const history = createHistory()
  const instrumentationMiddleware = trackingMiddleware([
    createTarget(
      () =>
        new Promise(() => {
          addSourceMiddleware()
        })
    ),
    createTarget(Segment.client()),
  ])

  const sentryReduxEnhancer = createReduxEnhancer()

  const middlewares = [
    thunk,
    instrumentationMiddleware,
    routerMiddleware(history),
  ]

  const composeEnhancers =
    (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose
  const enhancer = composeEnhancers(
    applyMiddleware(...middlewares),
    sentryReduxEnhancer
  )

  store = createStore(
    reducer,
    getInitialState(initialState) as RootState,
    enhancer
  )

  return {
    history,
    store,
  }
}

export const getStore = () => store
